import api from './apiService';
import { API_PATHS } from '../constants/portalApiPath';

const billingService = {
  // Pricing Plans
  listPlans: (data) => api.post(API_PATHS.BILLING_PLANS_LIST, data),
  getPlan: (data) => api.post(API_PATHS.BILLING_PLANS_GET, data),
  createPlan: (data) => api.post(API_PATHS.BILLING_PLANS_CREATE, data),
  updatePlan: (data) => api.post(API_PATHS.BILLING_PLANS_UPDATE, data),
  togglePlan: (data) => api.post(API_PATHS.BILLING_PLANS_TOGGLE, data),

  // Patient Plans
  assignPlan: (data) => api.post(API_PATHS.BILLING_PATIENT_PLAN_ASSIGN, data),
  closePlan: (data) => api.post(API_PATHS.BILLING_PATIENT_PLAN_CLOSE, data),
  getPatientPlan: (data) => api.post(API_PATHS.BILLING_PATIENT_PLAN_GET, data),
  listPatientPlans: (data) => api.post(API_PATHS.BILLING_PATIENT_PLAN_LIST, data),

  // Attendance
  markAttendance: (data) => api.post(API_PATHS.BILLING_ATTENDANCE_MARK, data),
  bulkMarkAttendance: (data) => api.post(API_PATHS.BILLING_ATTENDANCE_BULK_MARK, data),
  markCentreOff: (data) => api.post(API_PATHS.BILLING_ATTENDANCE_CENTRE_OFF, data),
  listAttendance: (data) => api.post(API_PATHS.BILLING_ATTENDANCE_LIST, data),

  // Wallet
  getWalletBalance: (data) => api.post(API_PATHS.BILLING_WALLET_BALANCE, data),
  addPayment: (data) => api.post(API_PATHS.BILLING_WALLET_ADD_PAYMENT, data),
  refundPayment: (data) => api.post(API_PATHS.BILLING_WALLET_REFUND, data),
  getWalletTransactions: (data) => api.post(API_PATHS.BILLING_WALLET_TRANSACTIONS, data),
  walletMonthCredits: (data) => api.post(API_PATHS.BILLING_WALLET_MONTH_CREDITS, data),
  getUnmarkedAttendance: () => api.post(API_PATHS.BILLING_ATTENDANCE_UNMARKED, {}),
  payInvoicesFromWallet: (data) => api.post(API_PATHS.BILLING_WALLET_PAY_INVOICES, data),
  // Money into a wallet by hand: an Admin adds it; the front desk asks and an Admin decides.
  addWalletCredit: (data) => api.post(API_PATHS.BILLING_WALLET_ADD_CREDIT, data),
  requestWalletCredit: (data) => api.post(API_PATHS.BILLING_WALLET_CREDIT_REQUEST_CREATE, data),
  listWalletCreditRequests: (data) => api.post(API_PATHS.BILLING_WALLET_CREDIT_REQUEST_LIST, data),
  decideWalletCreditRequest: (data) => api.post(API_PATHS.BILLING_WALLET_CREDIT_REQUEST_DECIDE, data),
  // The bill changed by hand to an agreed amount: an Admin changes it; the front desk asks.
  applyBillAdjustment: (data) => api.post(API_PATHS.BILLING_BILL_ADJUSTMENT_APPLY, data),
  requestBillAdjustment: (data) => api.post(API_PATHS.BILLING_BILL_ADJUSTMENT_REQUEST, data),
  listBillAdjustments: (data) => api.post(API_PATHS.BILLING_BILL_ADJUSTMENT_LIST, data),
  decideBillAdjustment: (data) => api.post(API_PATHS.BILLING_BILL_ADJUSTMENT_DECIDE, data),

  // Month-end wallet settlement (centre-off credits)
  walletSettlementList: (data) => api.post(API_PATHS.BILLING_WALLET_SETTLEMENT_LIST, data),
  walletSettlementSetAmount: (data) => api.post(API_PATHS.BILLING_WALLET_SETTLEMENT_SET_AMOUNT, data),
  walletSettlementApplyDifference: (data) => api.post(API_PATHS.BILLING_WALLET_SETTLEMENT_APPLY_DIFFERENCE, data),
  walletSettlementPatientMonth: (data) => api.post(API_PATHS.BILLING_WALLET_SETTLEMENT_PATIENT_MONTH, data),
  getServiceQuotaHistory: (data) => api.post(API_PATHS.BILLING_SERVICE_QUOTA_HISTORY, data),

  // Settlement & Invoices
  previewSettlement: (data) => api.post(API_PATHS.BILLING_SETTLEMENT_PREVIEW, data),
  generateInvoices: (data) => api.post(API_PATHS.BILLING_SETTLEMENT_GENERATE, data),
  getBillingInvoice: (data) => api.post(API_PATHS.BILLING_INVOICES_GET, data),
  listBillingInvoices: (data) => api.post(API_PATHS.BILLING_INVOICES_LIST, data),

  // Patient Billing Preview (for BookingModal)
  getPatientBillingPreview: (data) => api.post(API_PATHS.BILLING_PATIENT_PREVIEW, data),
};

export default billingService;
